import { useState } from 'react';
import { Grid } from '@mui/material';
import { Modal } from '@shared/components/modals/Modal';
import { TextInput } from '@shared/inputs/TextInput';
import { ModalFooter, StyledDialogContent } from '@styles/ModalStyles';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { ITeamTypeType } from '../../interfaces';

interface ITeamTypeModalProps {
  type: ITeamTypeType;
  teamTypeModalPosition : number;
  handleClose(): void;
  handleSubmit(type: ITeamTypeType): void;
}

export const TeamTypeModal = ({ type, teamTypeModalPosition, handleSubmit, handleClose }: ITeamTypeModalProps) => {
  const [name, setName] = useState(type.name);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    handleSubmit({
      ...type,
      name,
    });
  };

  return (
    <Modal 
      open
      hideBackdrop
      resetPosition={teamTypeModalPosition}
      title={`${type.id ? 'Edit' : 'Create'} Team Type`}
      dialogWidth="700px" 
      onClose={handleClose}
    >
      <StyledDialogContent>
        <form onSubmit={onSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextInput label="Team Type Name" value={name} onChange={({ target: { value } }) => setName(value)} />
            </Grid>

            <Grid item xs={12}>
              <ModalFooter style={{ gap: 0 }} margin="0 0 10px">
                <CancelButton onClick={handleClose} />
                <SaveButton disabled={!name} />
              </ModalFooter>
            </Grid>
          </Grid>
        </form>
      </StyledDialogContent>
    </Modal>
  );
};
